import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import Location from '../../components/Location/Location';
import ServiceTypes from '../../components/ServiceTypes/ServiceTypes';
import Mileage from '../../components/Mileage/Mileage';
import TimeSlots from '../../components/TimeSlots/TimeSlots';
import DateSelect from '../../components/DateSelect/DateSelect';
import Vehicle from '../../components/Vehicle/Vehicle';
import Customer from '../../components/Customer/Customer';
import ProblemDescription from '../../components/ProblemDescription/ProblemDescription';
import Overview from '../../components/Overview/Overview';
import Result from '../../components/Result/Result';
import MyToast from '../../components/Toast/MyToast';
import HTTPError from '../../components/HTTPError/HTTPError';
import parseDate from '../../util/parseDate';
import getAbsoluteHeight from '../../util/elementAbsoluteHeight';
import {getIncludedDays} from "../../util/includedDays";
import { Button, Col, Row, Alert } from "react-bootstrap";
import {fetchLocations, fetchServiceTypes, fetchSchedule, fetchSettings, fetchVehicleTypes, fetchMakes, fetchHolidays} from '../../http/http';

const apiURL = "https://api.trumpauto.eu/b/";

class Booking extends Component{

  constructor (props) {
    super(props);
    this.apiKey = props.APIKey;
    this.datePickerElementRef = React.createRef();
    this.timeSlotsElementRef = React.createRef();
    this.summaryElementRef = React.createRef();
    this.resultElementRef = React.createRef();

  }

  apiKey = null;

  state = {
    settings: {
        company: null,
        settings: {
            vehicleTypeRestrictionEnabled: false,
            vehicleMakeRestrictionEnabled: false,
            vehicleRegNoIsRequired: false
        }
    },
    vehicleTypes: [],
    vehicleMakes: [],
    waitingMsg: "Üks hetk, laen midagi...",
    waitingForHTTPResponse: {
      initialSettings: false,
      location: false,
      serviceTypes: false,
      schedule: false,
      bookingSubmit: false,
    },
    bookingErrors: [],
    bookingFailed: false,
    bookingSucceeded: false,
    hasHTTPError: false,
    displayOverview: false,
    locations: [],
    selectedLocationId: 0,
    serviceTypes: [],
    selectedServiceTypeIds: [],
    totalPrice: null,
    serviceTypeDescriptionActive: 0,
    selectedDate: null,
    bookableDays: [],
    disableHolidays: true,
    holidays: {
      fixedDate: [],
      movingDate: []
    },
    availableBookingTimes: [],
    selectedBookingSlot: null,
    customerInfo: {
      isValid: null,
      data: {
        nameFirst: {value: null, isValid: null, rules: {min: 1}},
        nameLast: {value: null, isValid: null, rules: {min: 1}},
        email: {value: null, isValid: null, rules: {email:true}},
        phone: {value: null, isValid: null, rules: {min: 5}},
        isCompany: false,
        company: {
          name: {value: null, isValid: null, rules: {min: 1}},
          address: {value: null, isValid: null, rules: {min: 5}},
          regNo: {value: null, isValid: null, rules: {min: 1}},
        }
      }
    },
    mileage : {
      isValid: null,
      value: "",
      isRequired: false
    },
    vehicleInfo: {
      isValid: null,
      data: {
        regNo: {value: null, isValid: null, rules: {min: 2}},
        type: {value: null, isValid: null, rules: {notZero: true}},
        make: {value: null, isValid: null, rules: {notZero: true}},
        model: {value: null, isValid: null, rules: {min: 1}},
      }
    },
    problemDescription: "",
    toast: {
      show: false,
      isError: false,
      heading: "",
      body: ""
    }
  };

  componentDidMount() {
    this.setState({selectedDate: parseDate(new Date())});
    this.fetchInitialInfo();

  }

  componentDidUpdate() {
    this.sendAppHeightToParent();
  }

  sendAppHeightToParent() {
    if(window && window.parent){
      const appContainer = document.getElementById("trumpauto-booking-app-container");
      const containerHeight = getAbsoluteHeight(appContainer);
      window.parent.postMessage({appHeight:containerHeight}, "*");
    }
  }

  showElements(elements) {
    const currentState = {...this.state.showElements};
    elements.each((el) => {
      currentState[el] = true;
    });
    this.setState({showElements: currentState});
  }

  setLoadingStatus(key, isLoading, text="", callback=null) {
    const loadingStatus = {...this.state.waitingForHTTPResponse}
    if(key in loadingStatus){
      loadingStatus[key] = isLoading;
      this.setState({waitingForHTTPResponse: loadingStatus, waitingMsg: text}, () => {
        if(typeof callback === "function"){
          callback();
        }
      });
    }
    if(typeof callback === "function"){
      callback();
    }
  }

  getHTTPHeaders = () => {
    return {
      "Authorization" : this.apiKey,
      "TR-Referred-For" : document.referrer,
      "Referrer-Policy" : "strict-origin-when-cross-origin"
    };
  }

  async fetchInitialInfo() {
    this.setLoadingStatus("initialSettings", true, "Üks hetk, laen seadeid...");

    await this.fetchSettings();
    await this.fetchVehicleTypes();
    await this.fetchVehicleMakes();
    await this.fetchNationalHolidays();


    if(!this.state.settings.settings.vehicleMakeRestrictionEnabled && !this.state.settings.settings.vehicleTypeRestrictionEnabled 
        && !this.state.settings.settings.vehicleRegNoIsRequired){
      await this.fetchLocations();
    }

    this.setLoadingStatus("initialSettings", false);

  }

  async fetchSettings() {
    try{
      const settings = await fetchSettings(this.getHTTPHeaders());
      this.setState({settings: settings});
      return settings;
      
    }catch(error){
      this.setState({hasHTTPError: true});
    }
  }

  async fetchVehicleTypes() {
    try{
      const vehicleTypes = await fetchVehicleTypes(this.getHTTPHeaders());
      this.setState({vehicleTypes: vehicleTypes});
      
    }catch(error){
      this.setState({hasHTTPError: true});
    }
  }

  async fetchVehicleMakes() {
    try{
      const vehicleMake = await fetchMakes(this.getHTTPHeaders());
      this.setState({vehicleMakes: vehicleMake});
      
    }catch(error){
      this.setState({hasHTTPError: true});
    }
  }

  async fetchNationalHolidays() {
    try{
      const holidays = await fetchHolidays(this.getHTTPHeaders());
      this.setState({holidays: holidays});
      
    }catch(error){
      this.setState({hasHTTPError: true});
    }
  }

  async fetchLocations() {
    this.setLoadingStatus("location", true, "Üks hetk, laen asukohti...");

    this.setState({locations:[], selectedLocationId:0, serviceTypes:[], selectedServiceTypeIds:[], availableBookingTimes:[], selectedBookingSlot:null}, async () => {
      if(this.state.settings.settings.vehicleTypeRestrictionEnabled && !this.state.vehicleInfo.data.type.isValid){
        this.setLoadingStatus("location", false);
        return;
      }
      if(this.state.settings.settings.vehicleMakeRestrictionEnabled && (
        !this.state.vehicleInfo.data.make.isValid || !this.state.vehicleInfo.data.model.isValid
      )){
        this.setLoadingStatus("location", false);
        return;
      }
      if(this.state.settings.settings.vehicleRegNoIsRequired && !this.state.vehicleInfo.data.regNo.isValid){
        this.setLoadingStatus("location", false);
        return;
      }

      try{
        const locations = await fetchLocations(this.state.vehicleInfo.data.type.value, this.state.vehicleInfo.data.make.value, this.getHTTPHeaders());
        if(locations.length===1){
          this.setState({locations: locations}, () => {
            this.locationChangedHandler(null, locations[0].id)
              .then(()=>{
                this.setLoadingStatus("location", false);
              });
            
          });

        }else{
          this.setState({locations: locations}, () => {
            this.setLoadingStatus("location", false);
          });
        }
        
      }catch(error){  
        this.setState({hasHTTPError: true}, () => {
          this.setLoadingStatus("location", false);
        });
      }
    })
   
  }

  locationChangedHandler = async (e, manuallySetLocationId=undefined) => {
    var selectedLocationId = 0;
    if(manuallySetLocationId!==undefined){
      selectedLocationId = manuallySetLocationId;
    }else{
      selectedLocationId = parseInt(e.target.value);
    }

    if(selectedLocationId==null || isNaN(selectedLocationId)){
      return;
    }

    this.setLoadingStatus("serviceTypes", true, "Üks hetk, laen teenuseid...");

    this.setState({selectedLocationId: selectedLocationId}, async () => {
      let serviceTypes= [];
      if(selectedLocationId!==0){
        try {
          serviceTypes = [...await fetchServiceTypes(selectedLocationId, this.state.vehicleInfo.data.type.value, this.state.vehicleInfo.data.make.value, this.getHTTPHeaders())];

        } catch (error) {
          this.setState({hasHTTPError: true});
        }
        
      }

      this.setState({serviceTypes: serviceTypes, availableBookingTimes: [], selectedServiceTypeIds: [], selectedBookingSlot: null}, () => {
        this.setLoadingStatus("serviceTypes", false);
      });
    });

  }

  checkIfMileageIsRequired = async () => {
    const selectedServicesThatRequireMileage = this.state.selectedServiceTypeIds.filter((el) => {
      const serviceType = this.state.serviceTypes.filter((st) => {
        return st.id===el;
      });
      if(serviceType.length>0){
        return serviceType[0].requireMileage;
      }
      return false;
    });

    const mileage = {...this.state.mileage};
    mileage.isRequired = selectedServicesThatRequireMileage.length>0;
    this.setState({mileage: mileage});

  }

  serviceTypeToggledHandler = (typeId) => {
    let currentlySelected = [...this.state.selectedServiceTypeIds];
    if(currentlySelected.indexOf(typeId)!==-1){
      currentlySelected.splice(currentlySelected.indexOf(typeId), 1);

    }else{
      currentlySelected.push(typeId);
    }

    const prices = this.state.serviceTypes
                    .filter(el => currentlySelected.indexOf(el.id)!==-1)
                    .map(el => {
                      return (el.price!==null && isNaN(el.price)===false)? parseFloat(el.price) : -1;
                    });
    let totalPrice = null;
    if(prices.indexOf(-1)===-1){
      totalPrice = prices.reduce((a, b) => a + b, null);
      if(isNaN(totalPrice) || totalPrice===null){
        totalPrice = null;
      }else{
        totalPrice = totalPrice.toFixed(2);
      }
    }
    
    this.setState({selectedServiceTypeIds: currentlySelected, totalPrice: totalPrice}, async () => {
      this.checkIfMileageIsRequired()
        .then(()=>{
          this.fetchAndAssignBookableDays(async () => await this.fetchSchedule());
        })
    });

  }

  fetchSchedule = async () => {
    if(this.state.bookableDays.length<1){
      return;
    }

    let schedule = [];
    const currentlySelectedServiceTypes = [...this.state.selectedServiceTypeIds];

    this.setLoadingStatus("schedule", true, "Üks hetk, otsin vabasid aegu...")

    if(this.state.selectedDate!==null && currentlySelectedServiceTypes.length>0 && this.state.selectedLocationId!==0){
      try {
        schedule = await fetchSchedule(this.state.selectedLocationId, this.state.selectedDate, currentlySelectedServiceTypes, this.getHTTPHeaders());

      } catch (error) {
        this.setState({hasHTTPError: true});
      }

    }

    this.setState({availableBookingTimes:schedule, selectedBookingSlot: null}, () => {
      this.setLoadingStatus("schedule", false);
    });

  }

  mileageChangeHandler = (event) => {
    const value = parseInt(event.target.value);
    const mileage = {...this.state.mileage};
    if(!isNaN(value)){
      mileage.value = value;
      mileage.isValid = true;
    }else if(event.target.value===""){
      mileage.value = "";
      mileage.isValid = false;
    }else{
      mileage.isValid = false;
    }

    this.setState({mileage: mileage});

  }

  dateChangeHandler = (date) => {
    this.setState({selectedDate: date}, async ()=>{
      await this.fetchSchedule();
      if(this.datePickerElementRef.current!==null){
        window.parent.postMessage({scrollHeight: this.datePickerElementRef.current.offsetTop-1}, "*");
      }
    });
  }

  timeSlotSelectedHandler = (slot) => {
    this.setState({selectedBookingSlot: slot}, ()=>{
      if(this.timeSlotsElementRef.current!==null){
        window.parent.postMessage({scrollHeight: this.timeSlotsElementRef.current.offsetTop-1}, "*");
      }
    });
  }

  timeSlotEmptyHandler = () => {
    this.setState({selectedBookingSlot: null}, ()=>{
        if(this.timeSlotsElementRef.current!==null){
          window.parent.postMessage({scrollHeight: this.timeSlotsElementRef.current.offsetTop-1}, "*");
        }
      }
    );
  };

  validateInput(value, rules) {
    let valid = true;
    value = value===null? "" : value;
    if("min" in rules){
      valid = (value.length<rules.min)? false : valid;
    }
    if("email" in rules){
      valid = (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value))? false : valid;
    }
    if("notZero" in rules){
      valid = (parseInt(value)===0)? false : valid;
    }

    return valid;
  }

  customerFieldChangeHandler = (key, event) => {
    const customer = {...this.state.customerInfo};
    let value = event.target.value;

    if(event.target.type==="checkbox"){
      if(key in customer.data){
        customer.data[key] = event.target.checked;
      }

    }else{
      if(key in customer.data){
        customer.data[key].value = value;
        customer.data[key].isValid = this.validateInput(value, customer.data[key].rules);
      }

    }
    
    this.setState({customerInfo: customer});

  }

  customerCompanyFieldChangeHandler = (key, event) => {
    const customer = {...this.state.customerInfo};

    if(key in customer.data.company){
      customer.data.company[key].value = event.target.value;
      customer.data.company[key].isValid = this.validateInput(event.target.value, customer.data.company[key].rules);
    }

    this.setState({customerInfo: customer});

  }

  vehicleFieldChangeHandler = (key, event) => {
    const vehicle = {...this.state.vehicleInfo};
    let newValue = event.target.value;
  
    if(key in vehicle.data){
      if(key==="type" && (isNaN(parseInt(newValue)) || newValue==="" || this.state.vehicleTypes.filter(el => el.id===parseInt(newValue)).length===0)){
        return;
      }

      if(key==="make" && (isNaN(parseInt(newValue)) || newValue==="" || this.state.vehicleMakes.filter(el => el.id===parseInt(newValue)).length===0)){
        return;
      }

      vehicle.data[key].value = newValue;
      if(
        (key==="type" && !this.state.settings.settings.vehicleTypeRestrictionEnabled) || 
        (key==="make" && !this.state.settings.settings.vehicleMakeRestrictionEnabled) ||
        (key==="model" && !this.state.settings.settings.vehicleMakeRestrictionEnabled)||
        (key==="regNo" && !this.state.settings.settings.vehicleRegNoIsRequired)  
        ){

        vehicle.data[key].isValid = true;

      }else{
        vehicle.data[key].isValid = this.validateInput(newValue, vehicle.data[key].rules);
      }

    }

    this.setState({vehicleInfo: vehicle}, () => {
      if(
        (key==="type" && this.state.settings.settings.vehicleTypeRestrictionEnabled) || 
        (key==="make" && this.state.settings.settings.vehicleMakeRestrictionEnabled) || 
        (key==="model" && this.state.settings.settings.vehicleMakeRestrictionEnabled && this.state.locations.length===0) || 
        (key==="regNo" && this.state.settings.settings.vehicleRegNoIsRequired && this.state.locations.length===0)
      ){
        this.fetchLocations();
        return;
      }

      if(
        (key==="model" && this.state.settings.settings.vehicleMakeRestrictionEnabled && newValue.length===0) || 
        (key==="regNo" && this.state.settings.settings.vehicleRegNoIsRequired && newValue.length===0)
      ){
        this.setState({locations:[], selectedLocationId: 0, availableBookingTimes:[], selectedBookingSlot:null, selectedServiceTypeIds:[]});
      }


    });

  }

  problemDescriptionChangehandler = (event) => {
    this.setState({problemDescription: event.target.value});
  }

  goToOverviewBtnClickHandler = () => {
    const customerInfo = {...this.state.customerInfo}
    const vehicleInfo = {...this.state.vehicleInfo}

    const isCompany = customerInfo.data.isCompany;
    let incorrectFieldsCustomer = 0;
    let incorrectFieldsVehicle = 0;

    let key;

    for(key in customerInfo.data){
      if(key==="isCompany"){
        continue;
      }
      if(key==="company"){
        if(isCompany===false){
          continue;
        }

        let key2;
        for(key2 in customerInfo.data[key]){
          customerInfo.data[key][key2].isValid = this.validateInput(customerInfo.data[key][key2].value, customerInfo.data[key][key2].rules);
          if(customerInfo.data[key][key2].isValid===false){
            incorrectFieldsCustomer++;
          }
        }

        continue;
      }

      customerInfo.data[key].isValid = this.validateInput(customerInfo.data[key].value, customerInfo.data[key].rules);
      if(customerInfo.data[key].isValid===false){
        incorrectFieldsCustomer++;
      }

    }

    for(key in vehicleInfo.data){
      if(
          (key==="type" && !this.state.settings.settings.vehicleTypeRestrictionEnabled) || 
          (key==="make" && !this.state.settings.settings.vehicleMakeRestrictionEnabled) ||
          (key==="model" && !this.state.settings.settings.vehicleMakeRestrictionEnabled) ||
          (key==="regNo" && !this.state.settings.settings.vehicleRegNoIsRequired)
        ){
        vehicleInfo.data[key].isValid = true;
        continue;
      }

      vehicleInfo.data[key].isValid = this.validateInput(vehicleInfo.data[key].value, vehicleInfo.data[key].rules);
      if(vehicleInfo.data[key].isValid===false){
        incorrectFieldsVehicle++;
      }

    }

    customerInfo.isValid = (incorrectFieldsCustomer===0);
    vehicleInfo.isValid = (incorrectFieldsVehicle===0);
    const mileageIsValid = (this.state.mileage.isRequired===false || (this.state.mileage.isRequired && this.state.mileage.isValid));

    const toast = {...this.state.toast};

    if(incorrectFieldsCustomer===0 && incorrectFieldsVehicle===0 && mileageIsValid){
      toast.show = false;
      toast.heading = "";
      toast.body = "";

      this.setState({displayOverview: true, customerInfo: customerInfo, vehicleInfo: vehicleInfo, toast: toast}, () => {
        if(this.summaryElementRef.current!==null){
          window.parent.postMessage({scrollHeight: this.summaryElementRef.current.offsetTop-1}, "*");
        }
      });
    }else{
      toast.body = "";
      toast.show = true;
      toast.isError = true;
      toast.heading = "Viga!";
      if(incorrectFieldsCustomer!==0 && incorrectFieldsVehicle!==0){
        toast.body = "Sisestatud sõiduki info ja Teie kontaktandmed on vigased!";
      }else if(incorrectFieldsCustomer!==0){
        toast.body = "Sisestatud kontaktandmed on vigased!";
      }else if(incorrectFieldsVehicle!==0){
        toast.body = "Sisestatud sõiduki info on vigane!";
      }

      if(!mileageIsValid){
        toast.body = toast.body + "\nLäbisõit on puudu või vigane!";
      }

      this.setState({customerInfo: customerInfo, vehicleInfo: vehicleInfo, toast: toast});
    }

  }

  overviewBackBtnClickHandler = () => {
    this.setState({displayOverview: false});
  }

  confirmBookingBtnHandler = () => {
    this.setLoadingStatus("bookingSubmit", true, "Üks hetk, kinnitan broneeringut...");

    const url = apiURL+"locations/"+this.state.selectedLocationId+"/book";
    const payload = this.getPayload();

    axios.post(url, payload, {headers: this.getHTTPHeaders()})
      .then(res => {
        this.setState({displayOverview: false, bookingErrors: [], bookingFailed: false, bookingSucceeded: true}, () => {
          this.setLoadingStatus("bookingSubmit", false, () => {
            if(this.resultElementRef.current!==null){
              window.parent.postMessage({scrollHeight: this.resultElementRef.current.offsetTop-1}, "*");
            }
          });
        });
      })
      .catch(error => {
        this.setState({displayOverview: false, bookingErrors: error.response.data.errors??[], bookingFailed: true}, () => {
          this.setLoadingStatus("bookingSubmit", false, () => {
            if(this.resultElementRef.current!==null){
              window.parent.postMessage({scrollHeight: this.resultElementRef.current.offsetTop-1}, "*");
            }
          });
        });
      });

  }

  hideToastHandler = () => {
    this.setState({
      toast: {
        show: false,
        isError: false,
        heading: "",
        body: ""
      }
    });
  }

  toggleServiceTypeDescriptionHandler = (serviceTypeId, isHidden) => {
    const activeServiceId = (isHidden)? 0 : serviceTypeId;
    this.setState({serviceTypeDescriptionActive: activeServiceId});
  }

  getPayload = () => {
    const currentState = {...this.state};

    let company = null;
    if(currentState.customerInfo.data.isCompany){
      company = {
        name: currentState.customerInfo.data.company.name.value,
        address: currentState.customerInfo.data.company.address.value,
        regNo: currentState.customerInfo.data.company.regNo.value,
      };
    }

    let selectedMakeName = "";
    const selectedMake = currentState.vehicleMakes.filter(el => el.id===parseInt(currentState.vehicleInfo.data.make.value));
    if(selectedMake.length>0){
      selectedMakeName = selectedMake[0].name;
    }

    return {
      customer: {
        nameFirst: currentState.customerInfo.data.nameFirst.value,
        nameLast: currentState.customerInfo.data.nameLast.value,
        email: currentState.customerInfo.data.email.value,
        phone: currentState.customerInfo.data.phone.value,
        organization: company
      },
      vehicle: {
        typeId: currentState.vehicleInfo.data.type.value,
        makeName: selectedMakeName,
        modelName: currentState.vehicleInfo.data.model.value,
        regNo: currentState.vehicleInfo.data.regNo.value
      },
      mileage: (currentState.mileage.isRequired)? currentState.mileage.value : null,
      sequence: currentState.selectedBookingSlot.sequence,
      additionalInfo: currentState.problemDescription
    };   
    
  }

  backFromErrorBtnHandler = () => {
    this.setState({
      displayOverview: false,
      bookingSucceeded: false,
      bookingFailed: false,
      bookingErrors: []
    });
  }

  backFromSuccesfulBtnHandler = () => {
    this.setState({
      displayOverview: false,
      bookingSucceeded: false,
      bookingFailed: false,
      bookingErrors: [],
      selectedServiceTypeIds: [],
      availableBookingTimes: [],
      selectedBookingSlot: null,
      problemDescription: ""
    });
  }

  fetchAndAssignBookableDays = (callback) => {
    const bookingPeriod = this.state.locations.filter(el => el.id===this.state.selectedLocationId)[0].allowedPeriod;
    const serviceDays = this.state.serviceTypes
      .filter(el=>this.state.selectedServiceTypeIds.indexOf(el.id)!==-1)
      .map(el => { return {bookingDays:el.bookingDays, bookingOnHolidaysEnabled:el.bookingOnNationalHolidaysEnabled} });
    const includedDays = getIncludedDays(bookingPeriod, serviceDays);

    let enableHolidays = false;
    if(serviceDays.length>0){
      enableHolidays = null;
      if(bookingPeriod===0){
        serviceDays.forEach(element => {
          if(enableHolidays===null){
            enableHolidays = element.bookingOnHolidaysEnabled;
          }else{
            enableHolidays = enableHolidays && element.bookingOnHolidaysEnabled;
          }
        });
  
      }else{
        enableHolidays = serviceDays[0].bookingOnHolidaysEnabled
      }
    }

    let selectedDate = new Date();
    if(includedDays.length!==0 && !this.dateFilter(selectedDate, includedDays)){
      do{
        selectedDate = moment(selectedDate).add(1, 'day').toDate();
  
      }while(!this.dateFilter(selectedDate, includedDays));

    }

    this.setState({bookableDays: includedDays, selectedDate: parseDate(selectedDate), disableHolidays: !enableHolidays}, callback);
  }

  dateFilter = (date, days) => {
    if(days.indexOf(date.getDay())===-1){
      return false;
    }
    
    return true;
  };

  getFormElementsToRender() {
    const elements = [];
    elements.push(
      <Vehicle
       key="vehicle-element" 
       isLoading={this.state.waitingForHTTPResponse.initialSettings}
       isTypeRequired={this.state.settings.settings.vehicleTypeRestrictionEnabled}
       isMakeRequired={this.state.settings.settings.vehicleMakeRestrictionEnabled}
       isRegNoRequired={this.state.settings.settings.vehicleRegNoIsRequired}
       loadingTxt={this.state.waitingMsg}
       vehicleTypes={this.state.vehicleTypes}
       vehicleMakes={this.state.vehicleMakes}
       fieldChanged={this.vehicleFieldChangeHandler}
       data={this.state.vehicleInfo} />
    )

    if(this.state.locations.length>0 || this.state.waitingForHTTPResponse.location){
      elements.push(
        <Location 
          key="location-element"
          isLoading={this.state.waitingForHTTPResponse.location}
          loadingTxt={this.state.waitingMsg}
          locations={this.state.locations} 
          selectedId={this.state.selectedLocationId}
          locationChanged={this.locationChangedHandler} />
      );
    }

    if(this.state.selectedLocationId!==0){
      elements.push(
        <ServiceTypes 
          key="service-types-element"
          isLoading={this.state.waitingForHTTPResponse.serviceTypes}
          loadingTxt={this.state.waitingMsg}
          serviceTypes={this.state.serviceTypes} 
          serviceTypeDescriptionActive={this.state.serviceTypeDescriptionActive}
          descriptionToggleHandler={this.toggleServiceTypeDescriptionHandler}
          changed={this.serviceTypeToggledHandler} 
          toggledItems={this.state.selectedServiceTypeIds}
          totalPrice={this.state.totalPrice} />
      );

    }

    if(this.state.selectedServiceTypeIds.length>0 && this.state.selectedLocationId!==0 && this.state.bookableDays.length>0 && this.state.mileage.isRequired){
      elements.push(
        <Mileage key="mileage-element" value={this.state.mileage.value} isValid={this.state.mileage.isValid} changed={this.mileageChangeHandler} />
      );

    }

    if(
      this.state.selectedServiceTypeIds.length>0 && this.state.selectedLocationId!==0 && this.state.bookableDays.length>0 
      && (this.state.mileage.isRequired===false || (this.state.mileage.isRequired && this.state.mileage.isValid))
      ){
      elements.push(
        <div ref={this.datePickerElementRef} key="date-select-element">
          <DateSelect 
            isLoading={this.state.waitingForHTTPResponse.schedule}
            loadingTxt={this.state.waitingMsg}
            selectedDate={this.state.selectedDate}
            includedDays={this.state.bookableDays}
            holidays={this.state.holidays}
            disableHolidays={this.state.disableHolidays}
            changed={this.dateChangeHandler} />
        </div>
      );

    }

    if(
      this.state.selectedServiceTypeIds.length>0 && this.state.selectedDate!==null && this.state.bookableDays.length>0
      && (this.state.mileage.isRequired===false || (this.state.mileage.isRequired && this.state.mileage.isValid))
      ){
      elements.push(
        <div ref={this.timeSlotsElementRef} key="time-slots-element">
          <TimeSlots 
            isLoading={this.state.waitingForHTTPResponse.schedule}
            loadingTxt={this.state.waitingMsg}
            slots={this.state.availableBookingTimes}
            selected={this.timeSlotSelectedHandler}
            emptied={this.timeSlotEmptyHandler}
            selectedSlot={this.state.selectedBookingSlot} />
        </div>
      );

    }

    if(this.state.selectedServiceTypeIds.length>0 && this.state.selectedDate!==null && this.state.bookableDays.length===0){
      elements.push(
        <Row
          key="next-btn-element"
          className="justify-content-md-center">

          <Col xs={12}>
            <Alert variant="danger">
              <Alert.Heading>Valitud teenuseid ei saa korraga broneerida</Alert.Heading>
              <p>Eemaldage mõni teenus ning proovige uuesti!</p>
            </Alert>
          </Col>

        </Row>
      );
    }
    
    if(
      this.state.selectedBookingSlot!==null && this.state.bookableDays.length>0
      && (this.state.mileage.isRequired===false || (this.state.mileage.isRequired && this.state.mileage.isValid))
      ){
      elements.push(
        <Customer 
          key="customer-element"
          customerFieldChanged={this.customerFieldChangeHandler}
          companyFieldChanged={this.customerCompanyFieldChangeHandler}
          data={this.state.customerInfo} />
      );

    }

    if(
      this.state.selectedBookingSlot!==null && this.state.bookableDays.length>0
      && (this.state.mileage.isRequired===false || (this.state.mileage.isRequired && this.state.mileage.isValid))
      ){
      elements.push(
        <ProblemDescription 
          key="problem-description-element" 
          value={this.state.problemDescription}
          changed={this.problemDescriptionChangehandler}/>
      );

    }

    if(
      this.state.selectedServiceTypeIds.length>0 && this.state.selectedDate!==null && this.state.selectedBookingSlot!==null && this.state.bookableDays.length>0
      && (this.state.mileage.isRequired===false || (this.state.mileage.isRequired && this.state.mileage.isValid))
      ){
      elements.push(
        <Row
         key="next-btn-element"
         className="justify-content-md-center">
          <Col xs={12}>
            <Button 
              onClick={this.goToOverviewBtnClickHandler}
              size="lg" 
              variant="primary" 
              className="float-right">
                Edasi <i className="fa fa-caret-right"></i>
            </Button>
          </Col>
        </Row>
      );
      
    }

    if(this.state.toast.show){
      elements.push(
        <MyToast 
          key="toast-element"
          heading={this.state.toast.heading}
          body={this.state.toast.body}
          isError={this.state.toast.isError}
          hideClicked={this.hideToastHandler} />
        );
    }

    return elements;

  }

  render() {
    let elements = [];
    if(this.state.hasHTTPError){
      elements.push(
        <HTTPError key="http-error-element"/>
      );

    }else if(this.state.displayOverview===true){
      elements.push(
        <div ref={this.summaryElementRef} key="overview-element" >
          <Overview 
            isLoading={this.state.waitingForHTTPResponse.bookingSubmit}
            loadingTxt={this.state.waitingMsg}
            data={this.state}
            btnBackClicked={this.overviewBackBtnClickHandler}
            confirmBtnClicked={this.confirmBookingBtnHandler} />
        </div>
      );

    }else if(this.state.bookingFailed || this.state.bookingSucceeded){
      elements.push(
        <div ref={this.resultElementRef} key="result-element" >
          <Result 
            bookingSucceeded={this.state.bookingSucceeded}
            bookingFailed={this.state.bookingFailed}
            bookingErrors={this.state.bookingErrors}
            onErrorGoBackBtnClicked={this.backFromErrorBtnHandler}
            onSuccessStartNewBtnClicked={this.backFromSuccesfulBtnHandler} />
        </div>
      );

    }else if(this.state.displayOverview===false){
      elements = [...this.getFormElementsToRender()];
      
    }

    return (
      <div>
        {elements}
      </div>
    );
  }

}

export default Booking;